<template lang="pug">
  .new-user-form.columns
    b-loading(:active="isLoading")

    .column.is-6: .box
      select-role(
        label="Роль*",
        v-model="value.role_id",
        :data.sync="value.role"
      )
      select-platform(
        v-if="isSuperAdmin===false",
        label="Платформа*",
        v-model="value.platform_id",
        :data.sync="value.platform",
        type="active"
      )
      b-field(label="Фамилия*", :type="errors && errors.last_name ? 'is-danger' : ''", :message="errors.last_name")
        b-input(v-model="value.last_name")
      b-field(label="Имя*", :type="errors && errors.first_name ? 'is-danger' : ''", :message="errors.first_name")
        b-input(v-model="value.first_name")
      b-field(label="Отчество", :type="errors && errors.patronymic ? 'is-danger' : ''", :message="errors.patronymic")
        b-input(v-model="value.patronymic")
      b-field(label="Email*", :type="errors && errors.email ? 'is-danger' : ''", :message="errors.email")
        b-input(v-model="value.email", type="email")
      div(class="control")
        b-field(label="Пароль*", :type="errors && errors.password ? 'is-danger' : ''", :message="errors.password")
          b-input(v-model="value.password")
      p(class='help')
        | не менее 8 символов
      br

      b-checkbox(v-model="value.is_send_password")
        | Отправить пароль на email
</template>

<script>
import { mapGetters } from 'vuex';
import BSelect from 'buefy/src/components/select/Select';
import SelectRole from '../components/SelectRole';
import { genPassword } from '../helpers/string';

export default {
  name: 'new-user-form',
  components: { SelectRole, BSelect },
  props: {
    value: Object,
    errors: Object,
  },

  data: () => ({
    isLoading: true,
    label: null,
    isSuperAdmin: null,
  }),

  computed: {
    ...mapGetters(['user']),
  },

  watch: {
    'value.role_id': function (roleId) {
      this.isSuperAdmin = roleId === 1;
    }
  },

  created() {
    this.isLoading = false;
    this.value.password = genPassword();
  },
};
</script>
